import "animate.css";
import { createBrowserHistory } from "history";
import React, { Suspense, useState } from "react";
import "react-notifications-component/dist/theme.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Router } from "react-router-dom";
import "./App.scss";
import "./global.scss";
import Routers from "./navigators/Routers";
import { StoreProvider } from "./store/Store";
import { Modal } from "react-bootstrap";
import { Amplify } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { getMyProfile } from "src/components/Dashboard/Profile/api";
import { storeUser } from "./features/user/userSlice";
import { fetchTimeSlots } from "./features/timeslots/timeslotsActions";
import { fetchDiagnosisLabTests, fetchDiagnosisNotes, fetchDiagnosisTemplates, fetchPrescriptionTemplates } from "./features/templates/templatesActions";
import { fetchPatients } from "./features/patients/patientsActions";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
});


Amplify.configure({
  API: {
    GRAPHQL: {
      endpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
      region: process.env.REACT_APP_REGION,
      defaultAuthMode: "userPool",
    },
  },
  Auth: {
    Cognito: {
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      userPoolId: process.env.REACT_APP_USERPOOL_ID,
      userPoolClientId: process.env.REACT_APP_USERPOOL_WEB_CLIENT,
      loginWith: {
        email: true,
        username: false,
      },
      mfa: {
        totpEnabled: false,
        smsEnabled: false,
      },
      allowGuestAccess: true, // Enable guest access for unauthenticated users
    },
  },
});

const App = () => {
  const [isOpen, setOpen] = useState(false);
  const userStatus = useSelector((state) => state.user.status);
  const loginStatus = sessionStorage.getItem("loginStatus");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const isVideoCall = window.location.pathname.includes('video-call') || window.opener !== null;
    if (isVideoCall) {
      console.log('VideoCall detected - skipping data refetch');
    }


    const fetchUserProfile = async () => {
      if (!isVideoCall && userStatus === "idle" && loginStatus === "true") {

        try {
          const userInfo = await getMyProfile();
          dispatch(storeUser(userInfo));
          
          sessionStorage.setItem("userRole", userInfo.roles);
          sessionStorage.setItem("clinic_id", userInfo.clinicId);
          sessionStorage.setItem("doctorVerified", userInfo.doctorVerified);
          sessionStorage.setItem("role-id", userInfo.id);

          await Promise.all([
            dispatch(fetchPatients('', true)),
            dispatch(fetchTimeSlots(true)),
            dispatch(fetchPrescriptionTemplates()),
            dispatch(fetchDiagnosisTemplates()),
            dispatch(fetchDiagnosisNotes()),
            dispatch(fetchDiagnosisLabTests()),
          ])
        } catch (error) {
          console.error("Error during user status check:", error);
        }
      }
    }

    fetchUserProfile();
  }, [userStatus, loginStatus, dispatch]);

  React.useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight - 1}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
  }, []);

  const history = createBrowserHistory();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <StoreProvider>
          <Suspense fallback={"Loading..."}>
            <Router history={history}>
              <Routers />
              <Modal
                size="md"
                show={isOpen}
                onHide={() => setOpen(false)}
                dialogClassName="docg-modal"
                aria-labelledby="example-custom-modal-styling-title"
                centered
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="p-4">
                  Please use landscape mode for better user experience
                </Modal.Body>
              </Modal>
              <ReactQueryDevtools
                initialIsOpen={false}
                toggleButtonProps={{ style: { opacity: 0.2 } }}
              />
            </Router>
          </Suspense>
        </StoreProvider>
      </QueryClientProvider>
    </>
  );
};

export default App;